
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[prismicUid]/[variant]",
      function () {
        return require("private-next-pages/[prismicUid]/[variant].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[prismicUid]/[variant]"])
      });
    }
  